import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodeTextField } from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { twMerge } from "@/utils/twMerge";

import type { PlaceholderNodeModel } from "@/models/nodes/PlaceholderNodeModel";

type Props = {
  node: PlaceholderNodeModel;
  className?: string;
};

export const PlaceholderLinkField = observer(function PlaceholderLinkField({
  node,
  className,
}: Props) {
  const t = useTranslations("sidebar.activeNode");

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    node.doc.transact(() => {
      const value = e.target.value.replace(/\s/g, "");
      node.linkId = value || undefined;
    }, "PlaceholderLinkField:setLinkId");
  };

  return (
    <NodeTextField
      id={`link-id-${node.id}`}
      value={node.linkId ?? ""}
      name={t("fields.labels.right-bottom")}
      onChange={handleOnChange}
      labelProps={{
        className: twMerge("shadow-block dark:shadow-block-inverted", className),
        label: t("fields.labels.right-bottom"),
      }}
    />
  );
});
